const DEFAULT_BASE_URL = 'http://localhost:8083'

const configuredBaseUrl = import.meta.env.VITE_API_BASE_URL

export const API_BASE_URL = (configuredBaseUrl === undefined ? DEFAULT_BASE_URL : configuredBaseUrl).replace(/\/$/, '')

export async function request(path, options = {}) {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
    ...options,
  })

  if (!response.ok) {
    throw new Error(`API 요청에 실패했습니다. (${response.status})`)
  }

  const body = await response.json()
  if (body.code !== 0) {
    throw new Error(body.message || 'API 요청에 실패했습니다.')
  }
  return body.data
}
